// 条件选股
import request from '@/utils/request'
import { f10url, eduurl } from './config'
// import { logicalExpression } from '@babel/types';
type dataType = any
export default {
  // 基金挖掘直方图
  getReportDigFundHistogram(data: dataType): Promise<{
    response?: Response
  }> {
    return request({
      url: f10url + '/infoapi/v2/ReportDigFundHistogram',
      method: 'post',
      data: data.data,
      headers: data.headers
    })
  },
  // 基金挖掘直方图
  getReportDigFundIndex(data: dataType): Promise<{
    response?: Response
  }> {
    return request({
      url: f10url + '/infoapi/v2/ReportDigFundIndex',
      method: 'post',
      data: data.data,
      headers: data.headers
    })
  }
}
